/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedRecentHistoryTracker_item$ref: FragmentReference;
export type PdpSharedRecentHistoryTracker_item = {|
  +contemporaryTrackingString: string,
  +firstPhotoWebPath: ?string,
  +pdpURL: ?string,
  +title: ?string,
  +browseUrl: ?string,
  +categoryCode: ?string,
  +serviceId: ?string,
  +categoryPath: ?string,
  +seller: ?{|
    +serviceId: ?string
  |},
  +isComplete: ?boolean,
  +isListingListed: ?boolean,
  +$refType: PdpSharedRecentHistoryTracker_item$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "PdpSharedRecentHistoryTracker_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "categoryCode",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "contemporaryTrackingString",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pdpURL",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "browseUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstPhotoWebPath",
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "small",
          "type": "ImageVersionTypeName!"
        }
      ],
      "storageKey": "firstPhotoWebPath(size:\"small\")"
    },
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "categoryPath",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": null,
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isComplete",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isListingListed",
      "args": null,
      "storageKey": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '19daaa7357d8d5c1c93c5f0d5189bea2';
module.exports = node;
